<div class="spinner">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
